var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../components/actor/Actor_';
let AbfragerAssociateAssociation = class AbfragerAssociateAssociation extends React.PureComponent {
    get isVisible() {
        if (this.props.association.isAssociationFinished)
            return true;
        return false;
    }
    render() {
        const { association } = this.props;
        return (React.createElement(Actor_, { actor: association, key: association.id, structureTemplate: React.createElement("div", { "data-aspect": "associated", className: "btn btn-success btn-lg", style: {
                    lineHeight: 1.1,
                    marginBottom: 4,
                    visibility: this.isVisible ? 'visible' : 'hidden',
                    borderRadius: 10
                }, key: association.id },
                React.createElement("div", { "data-aspect": "inner", id: "inner" })) }));
    }
};
AbfragerAssociateAssociation = __decorate([
    observer
], AbfragerAssociateAssociation);
export { AbfragerAssociateAssociation };
